
import { giftCache, giftExpiredTime } from '@xt/client/helpers'
import { Observer } from 'mobx-vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Observer
@Component
export default class GiveawayRefundModal extends Vue {
  @Prop() dataSource: any

  get PageStore() {
    return this.$store.$storeUser
  }

  get expireTime() {
    return this.moment(this.dataSource.expireTime).format('YYYY-MM-DD HH:mm:ss')
  }

  close() {
    giftCache.set(`refund-notice-${this.dataSource.orderNo}`, 'expired', giftExpiredTime)
    this.PageStore.removeUniformGift()
  }

  clearGiveawayRefundData() {
    this.PageStore.removeUniformGiftData()
    this.PageStore.removeUniformGift()
  }

  async confirm() {
    try {
      const resp = await this.PageStore.onGiveawayRefundConfirm(this.dataSource.giftsRecordId)
      if (resp === true) {
        this.clearGiveawayRefundData()
      }
    } catch (error) {}
  }

  async reject() {
    try {
      const resp = await this.PageStore.onGiveawayRefundReject(this.dataSource.giftsRecordId)
      if (resp === true) {
        this.clearGiveawayRefundData()
      }
    } catch (error) {}
  }
}
